import { createAsyncThunk } from '@reduxjs/toolkit';

import { createAndUpdateTimelineTasksService } from 'scenes/Timelines/services/createAndUpdateTimelineTasks.service';
import {
  selectDeletedTasks,
  selectModifiedTasks,
  selectNewTasksArray,
  selectSelectedTimeline,
  selectSelectedTimelineId,
} from '../selectors/timelineSelectors';

export const saveTimelineTasks = createAsyncThunk(
  'timelines/saveTimelineTasks',
  async (_, { getState }) => {
    const state = getState();

    const timelineId = selectSelectedTimelineId(state);

    const selectedTimeline = selectSelectedTimeline(state);

    const modifiedTasks = selectModifiedTasks(state);
    const newTasks = selectNewTasksArray(state);
    const deletedTasks = selectDeletedTasks(state);
    console.log('modifiedTasks', modifiedTasks);
    console.log('newTasks', newTasks);
    console.log('deletedTasks', deletedTasks);

    const response = await createAndUpdateTimelineTasksService(
      selectedTimeline.projectId,
      timelineId,
      {
        tasksToCreate: newTasks,
        tasksToUpdate: modifiedTasks,
        tasksToDelete: deletedTasks,
      }
    );

    console.log('Tasks saved successfully:', response);
    return response;
  }
);
